import { render } from "./PortalResources.vue?vue&type=template&id=0300803c"
import script from "./PortalResources.vue?vue&type=script&lang=js"
export * from "./PortalResources.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__